module.exports = __webpack_public_path__ + "img/jiantou.068c453a.png";